/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult } from "../models/index";
import { ApiResultFromJSON, ApiResultToJSON } from "../models/index";

export interface ReleaseDeviceServiceRequest {
    deviceServiceInstanceId: string;
    durationSeconds?: number;
    acceptNewConnections?: string;
}

/**
 *
 */
export class MaintenanceHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Release/Reactivate device service - disallow new connections and kick all existing connections, or re-allow connections again
     */
    async releaseDeviceServiceRaw(
        requestParameters: ReleaseDeviceServiceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceServiceInstanceId"] == null) {
            throw new runtime.RequiredError(
                "deviceServiceInstanceId",
                'Required parameter "deviceServiceInstanceId" was null or undefined when calling releaseDeviceService().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceServiceInstanceId"] != null) {
            queryParameters["deviceServiceInstanceId"] =
                requestParameters["deviceServiceInstanceId"];
        }

        if (requestParameters["durationSeconds"] != null) {
            queryParameters["durationSeconds"] =
                requestParameters["durationSeconds"];
        }

        if (requestParameters["acceptNewConnections"] != null) {
            queryParameters["acceptNewConnections"] =
                requestParameters["acceptNewConnections"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/maintenance/release-device-service`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Release/Reactivate device service - disallow new connections and kick all existing connections, or re-allow connections again
     */
    async releaseDeviceService(
        requestParameters: ReleaseDeviceServiceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.releaseDeviceServiceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
